import {EntiteModel} from './entite.model';

export class EntiteModelExtended extends EntiteModel {
  constructor(id: number, code: string, libelle: string, actif: boolean, public editable: boolean = true) {
    super(id, code, libelle, actif);
  }
}
